package org.vreo.devicehub.features.device.presentation.deviceManagement.messages

import androidx.compose.ui.graphics.ImageBitmap

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.core.domain.device.device.AnprDevice
import org.vreo.devicehub.features.core.domain.device.message.AnprCameraMessage

/**
 * Message list state. Represents state of message list screen.
 */
data class MessageListState(
    val isLoading: Boolean = false,
    val error: UiText? = null,

    val isDeviceActive: Boolean = false,
    val deviceName: String = "",

    val messages: List<AnprCameraMessage> = emptyList(),
    val selectedMessage: AnprCameraMessage? = null,
    val image: ImageBitmap? = null,
)